import React from 'react';

export default function TableLayout({ children }) {
  return <div className='overflow-auto'>{children}</div>;
}
